import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { OPTIONS_ACTIVE_INACTIVE } from "@app/pages/samples/components/analysisComponents/BR/utils/constants";

const InstalacionesForm = () => {
  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MTextField
          key={"codigo"}
          name={"codigo"}
          label={"Código"}
          type="text"
          fullWidth
          validation={{ required: `El campo código es requerido` }}
        />
        <MTextField
          key={"descripcion"}
          name={"descripcion"}
          label={"Descripción"}
          type="text"
          fullWidth
          validation={{ required: `El campo descripción es requerido` }}
        />
        <MDatePicker
          key={"fecha_inicio"}
          name={"fecha_inicio"}
          pickerType="date"
          label={"Fecha inicio"}
        />
        <MDatePicker
          key={"fecha_limite"}
          name={"fecha_limite"}
          pickerType="date"
          label={"Fecha límite"}
        />
        <MAutocomplete
          name="activo"
          options={OPTIONS_ACTIVE_INACTIVE}
          label="Activo"
          getOptionLabel={(option) => `${option.label}`}
          validation={{ required: `El campo activo es requerido` }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default InstalacionesForm;
